import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "@punto-firma/ui/components/fonts";
import "@punto-firma/ui/globals.css";

import { App } from "./app";
import { initI18n } from "./i18n/i18n";

initI18n();

const enableMocks = async () => {
  if (import.meta.env.MODE !== "mock") return;
  const { startMockWorker } = await import("./mocks/browser");
  await startMockWorker();
};

const root = document.getElementById("root");
if (!root) throw new Error("Falta #root en index.html");

void enableMocks().then(() => {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
